module.exports = __webpack_public_path__ + "assets/priceoff0.jpg?1392c7b32296c7ffe712f6c9cd48261b";